import { render } from "./RadioGroup.vue?vue&type=template&id=44acfcba&ts=true"
import script from "./RadioGroup.vue?vue&type=script&lang=ts"
export * from "./RadioGroup.vue?vue&type=script&lang=ts"

import "./RadioGroup.vue?vue&type=style&index=0&id=44acfcba&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__